import React from "react";
import { BrowserRouter as Router, Routes, Route, MemoryRouter } from "react-router-dom";
import { Hero } from "./components/Hero";
import { Overview } from "./components/Overview";
import { HowItWorks } from "./components/HowItWorks";
import { Privacy } from "./components/Privacy";
import { FAQ } from "./components/FAQ";
import { SignUpForm } from "./components/SignUpForm";
import { MessageExamples } from "./components/MessageExamples";
import { Team } from "./components/Team";
import { Testimonials } from "./components/Testimonials";
import { Footer } from "./components/Footer";
import { Terms } from "./components/Terms";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { PrivacyPage } from "./components/PrivacyPage";
const MainContent = () => <>
    <Hero data-id="element-0" />
    <Overview data-id="element-1" />
    <Team data-id="element-2" />
    <HowItWorks data-id="element-3" />
    <MessageExamples data-id="element-4" />
    <Testimonials data-id="element-5" />
    <Privacy data-id="element-6" />
    <FAQ data-id="element-7" />
    <SignUpForm data-id="element-8" />
  </>;
export function App() {
  return <MemoryRouter data-id="element-9">
      <main className="w-full min-h-screen bg-white font-['Montserrat']" data-id="element-10">
        <Routes data-id="element-11">
          <Route path="/" element={<MainContent data-id="element-13" />} data-id="element-12" />
          <Route path="/terms" element={<Terms data-id="element-15" />} data-id="element-14" />
          <Route path="/privacy" element={<PrivacyPage data-id="element-17" />} data-id="element-16" />
        </Routes>
        <Footer data-id="element-18" />
        <WhatsAppButton data-id="element-19" />
      </main>
    </MemoryRouter>;
}